<template>
  <div id="scrollTop">
    <v-app-bar
      :absolute="
        ($route.params.event && $vuetify.breakpoint.mobile) ||
          ($route.path.includes('casino') && $vuetify.breakpoint.mobile)
      "
      app
      clipped-left
      class="colorDominant colorAppBar"
      :style="
        $vuetify.breakpoint.mobile || $store.state.showDialogRegister
          ? 'z-index: 11;'
          : 'z-index: 700;'
      "
    >
      <template v-if="!($route.matched[0].name === 'page')">
        <v-app-bar-nav-icon
          @click.stop="menuDrawer = !menuDrawer"
        ></v-app-bar-nav-icon>
      </template>

      <!-- PROD: LOGO OPERATOR OFICIAL!!!! -->
      <template v-if="$domain() != 'sys'">
        <div
          class="d-flex pr-4 pl-2 cursor-pointer mr-3 test-class"
          :style="
            `
            background-image: ${backgroundImageLogo};
            background-repeat: no-repeat;
            background-position: left center;
            background-size: contain;
            height: 48px;
            width: 100%;
            max-width: 220px;          
          `
          "
          v-on:click="toRoute('main')"
        ></div>
      </template>
      <!-- DEV: LOGO DE TESTES ${$domain()}-->
      <template v-else>
        <div
          class="d-flex pr-4 pl-2 cursor-pointer mr-3"
          :style="
            `
            background-image: url(${$operatorLogoUrl($domain())});
            background-repeat: no-repeat;
            background-position: left center;
            background-size: contain;
            height: 48px;
            width: 100%;
            max-width: 220px;          
          `
          "
          v-on:click="toRoute('main')"
        ></div>
      </template>

      <!-- NAME OPERATOR -->
      <v-toolbar-title
        class="px-4 cursor-pointer"
        v-show="$vuetify.breakpoint.mdAndUp && titleAppBar"
        v-on:click="toRoute('home')"
        >{{ client }}</v-toolbar-title
      >
      <!-- <div class="flex-grow-1"></div> -->

      <!-- SEARCH EVENTS -->
      <!-- <Search
        v-if="!$vuetify.breakpoint.smAndDown && !$route.path.includes('casino')"
        class="mx-auto"
        style="max-width: 300px"
      /> -->

      <!-- MOBILE TABS -->
      <template
        v-if="
          $vuetify.breakpoint.smAndDown && !($route.matched[0].name === 'page')
        "
        v-slot:extension
      >
        <MobileTabs :logged="logged" />
      </template>

      <div class="flex-grow-1" v-if="$vuetify.breakpoint.mdAndUp"></div>

      <!-- DESKTOP MENU -->
      <v-toolbar-items v-if="$vuetify.breakpoint.mdAndUp" class="mx-2 ml-4">
        <!-- BTN Esportes - User FINAL -->
        <v-btn
          v-if="!$isAgent()"
          v-on:click="toRoute('home')"
          text
          :class="{
            'v-btn--active':
              ($route.path.includes('/home') &&
                !$route.path.includes('casino')) ||
              $route.path.includes('/bt'),
          }"
          class="caption c-btn"
          >{{ $t("sports") }}</v-btn
        >

        <!-- BTN Esportes - Agent -->
        <v-btn
          v-if="$isAgent()"
          :to="{
            name: 'bigTable',
          }"
          text
          :class="{
            'v-btn--active': $route.path == '/home' || $route.path == '/bt',
          }"
          class="caption c-btn"
          >{{ $t("sports") }}</v-btn
        >

        <!-- BTN Live - UserFinal and Agent -->
        <v-btn
          v-on:click="toRoute('live')"
          text
          :class="{ 'v-btn--active': $route.path == '/live' }"
          class="caption c-btn"
          >{{ $t("live") }}</v-btn
        >

        <!-- Encerrar aposta - Apostador - Credit 2 -->
        <v-btn
          v-if="!$isAgent() && logged"
          v-on:click="toRoute('myBets')"
          text
          :class="{
            'v-btn--active': $route.path.includes('myBets'),
          }"
          class="caption c-btn"
          >{{ $t("bets") }}
        </v-btn>

        <!-- Casino -->
        <v-btn
          v-if="
            (!$isAgent() && casino == '1') || (!$isAgent() && casino == '2')
          "
          :to="{
            name: 'casinoLobby',
            params: { casinoType: 'casino' },
          }"
          text
          class="caption c-btn"
          :class="{
            'v-btn--active':
              $route.path.includes('casino') &&
              $route.params.casinoType === 'casino',
          }"
        >
          {{ $t("casino") }}
        </v-btn>

        <v-btn
          v-if="!$isAgent() && casino == '2'"
          :to="{
            name: 'casinoLobby',
            params: { casinoType: 'live' },
          }"
          text
          class="caption c-btn"
          :class="{
            'v-btn--active':
              $route.path.includes('casino') &&
              $route.params.casinoType === 'live',
          }"
        >
          {{ $t("liveCasino") }}
        </v-btn>

        <!-- BTN Validate Pré Bet - Agent -->
        <v-btn
          v-if="$isAgent() && showValidatePreBet()"
          :to="{
            name: 'validatePreBet',
          }"
          text
          :class="{
            'v-btn--active': $route.path == '/validatePreBet',
          }"
          class="caption c-btn"
          >{{ $t("validate") }}</v-btn
        >

        <!-- Promoções -->
        <v-btn
          v-if="$isCreditOnline() && !$isAgent()"
          :to="{
            name: 'AllPromotions',
          }"
          text
          :class="{
            'v-btn--active': $route.path == '/promotions',
          }"
          class="caption c-btn"
          >{{ $t("promotions") }}</v-btn
        >
      </v-toolbar-items>

      <div class="flex-grow-1"></div>
      <!-- Buttton Languages -->
      <template v-if="!$vuetify.breakpoint.xsOnly">
        <ButtonLanguges />
      </template>

      <template v-if="logged">
        <!-- SUSV2-4 -->
        <v-btn
          icon
          @click="goToMessages()"
        >
          <v-badge
            :content="messagesNotRead"
            :value="messagesNotRead"
            color="primary"
            overlap
          >
            <v-icon>mdi-bell</v-icon>
          </v-badge>
        </v-btn>
        <!-- User -->
        <User v-if="!domainAgent" />
        <!-- Agent -->
        <UserAgent v-if="domainAgent" />
      </template>
      <template v-else>
        <DialogRegister idDialog="appbar" />
        <Login />
      </template>
    </v-app-bar>

    <template v-if="!($route.matched[0].name === 'page')">
      <!-- Menu Left Agent -->
      <MenuNavigationAgent
        v-if="domainAgent"
        :drawer_prop="menuDrawer"
        v-on:update:drawer="menuDrawer = $event"
        :style="styleZindex"
      />

      <!-- Menu Left Casino -->
      <MenuCasino
        v-else-if="isCasinoView"
        :drawer_prop="menuDrawer"
        v-on:update:drawer="menuDrawer = $event"
        :style="styleZindex"
      />
      <!-- Menu Left User -->
      <MenuNavigation
        v-else
        :drawer_prop="menuDrawer"
        v-on:update:drawer="menuDrawer = $event"
        :style="styleZindex"
      />
    </template>
  </div>
</template>
<script>
import Login from "@/components/login/dialog.vue";
import User from "@/components/user/";
// import Search from "@/components/search/search";
import MenuNavigation from "@/components/menu-sports/menu.vue";
import MenuCasino from "@/components/casino/MenuCasino.vue";
import DialogRegister from "@/views/home/register/dialog-register";
import permissions from "@/util/permissions.js";
import ButtonLanguges from "@/components/btn-languages/btn-languages";
import MobileTabs from "@/components/appbar/mobile_tabs.vue";
// Agent
import { UserAgent, MenuNavigationAgent } from "@/components/agent";

export default {
  name: "appbar",
  components: {
    Login,
    User,
    UserAgent,
    DialogRegister,
    MenuNavigation,
    MenuNavigationAgent,
    MenuCasino,
    // Search,
    ButtonLanguges,
    MobileTabs,
  },
  data: () => ({
    tile: false,
    domain: "",
    menuDrawer: null,
    titleAppBar: true,
    backgroundImageLogo: "",
    countMessages: 0,
  }),

  watch: {
    $route(val) {
      if (val.name === "casinoGame") {
        this.menuDrawer = false;
      }
    },
    openMenu(val) {
      if (val != null) {
        this.menuDrawer = val;
        this.$store.commit("setOpenMenu", null);
      }
    },
    gameViewMode(val) {
      if (val === "fullscreen") {
        this.menuDrawer = false;
      }
    },
    logged(val) {
      // Chama o endpoint de notificações assim que
      // o usuário logar
      val && this.lastNotifications();
    }
  },
  computed: {
    messagesNotRead() {
      return this.$store.state.messagesNotRead;
    },
    gameViewMode() {
      return this.$store.state.modeViewGame;
    },
    casino() {
      return this.$store.state.operators.casino;
    },
    isCasinoView() {
      return (
        this.$route.params.casinoType === "casino" ||
        this.$route.params.casinoType === "live"
      );
    },
    logged: function() {
      return this.$store.state.logged.status;
    },
    affiliateLevel() {
      return this.$store.state.logged.data.is_afilliate;
    },

    totalNotifications() {
      return this.$store.state.logged.data.total_notificacao;
    },

    domainAgent() {
      return this.$isAgent();
    },
    innerSport() {
      return this.$store.state.innerSport;
    },
    client() {
      return this.$store.state.operators.operator_name;
    },
    nameSport() {
      return this.$store.getters.getNameSportById("6046");
    },
    styleZindex() {
      return this.$vuetify.breakpoint.mobile ? { zIndex: "101" } : {};
    },
    openMenu() {
      return this.$store.state.openMenu;
    },
  },

  created() {
    // Se o usuário estiver logado e atualizar a pagina,
    // chama o endpoint de notificações
    this.logged && this.lastNotifications();
  },

  mounted() {
    this.domain = this.$domain();
    this.titleAppBar = permissions().titleAppBar;
    // Armazenando a Logo
    this.backgroundImageLogo = `url(${this.$operatorLogoUrl(this.$domain())})`;
  },

  methods: {
    lastNotifications() {
      this.$axios
        .get("/player/notifications/list")
        .then((resp) => {
          if (resp.status === 200) {
            let items = resp.data.dados;
            let notRead = 0;

            items.forEach((item) => {
              notRead += item.viewed == "0" ? 1 : 0;
              item.date_notification = new Date(
                item.date_notification
              ).toLocaleString();
            });

            this.$store.commit("setMessagesNotRead", notRead);
          }
        })
        .catch(() => {})
    },

    goToMessages() {
      this.$router.push({name: 'Mensagens'})
    },

    toRoute: function(page) {
      if (page === "main") {
        const homePage = this.$store.state.operators.home_page;

        if (homePage === "casino") {
          this.$router.push({ name: "casinoHome" });
        } else {
          const route = permissions().bigTable
            ? {
                name: "bigTable",
                hash: this.$vuetify.breakpoint.smAndDown ? "#scrollTop" : "",
              }
            : {
                name: "Sports",
                query: {
                  sport: this.nameSport,
                  live: this.nameSport,
                },
                hash: this.$vuetify.breakpoint.smAndDown ? "#scrollTop" : "",
              };

          this.$router.push(route).catch(() => {});
        }

        return;
      }

      if (page === "home") {
        var route = permissions().bigTable
          ? {
              name: "bigTable",
              hash: this.$vuetify.breakpoint.smAndDown ? "#scrollTop" : "",
            }
          : {
              name: "Sports",
              query: {
                sport: this.nameSport,
                live: this.nameSport,
              },
              hash: this.$vuetify.breakpoint.smAndDown ? "#scrollTop" : "",
            };
        this.$router.push(route).catch(() => {});
      }

      if (page === "live") {
        this.$router
          .push({
            name: "live",
            query: {
              live: this.nameSport,
            },
            hash: this.$vuetify.breakpoint.smAndDown ? "#scrollTop" : "", // ajust scroll top mobile
          })
          .catch(() => {});
      }

      if (page === "myBets") {
        this.$router
          .push({
            name: "myBets",
            hash: "#scrollTop", // ajust scroll top mobile
          })
          .catch(() => {});
      }
    },
    showValidatePreBet() {
      let affiliateLevel = this.affiliateLevel;
      // affiliateStatus:
      // 0 == agent;
      // 1 == affiliate(ex.: influencer);
      // 2 == agent && Affiliate

      // Até o momento, do que foi passado:
      // 0 == não oculta menus nem tab 'validar', 1 == oculta menus e tab 'validar' e 2 == não oculta menus nem tab 'validar'
      if (affiliateLevel == 0) {
        return true;
      } else if (affiliateLevel == 1) {
        return false;
      } else if (affiliateLevel == 2) {
        return true;
      }
    },
  },
};
</script>
